import React from 'react';
import { Button, Typography } from 'antd';
import { Link } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const Landing = () => {
    const backgroundSrc = `${process.env.PUBLIC_URL}/background.svg`;

    return (
      <div className="landing-screen">
        <div className="hero-zone">
          <div className="landing-hero">
            <Title level={1} className="landing-title">Synopticus</Title>
            <Paragraph className="landing-subtitle">
              Build bilingual books in a single PDF — align chapters, compare translations, and study languages through familiar stories.
            </Paragraph>
            <Link to="/steps/1">
              <Button type="primary" size="large">Create</Button>
            </Link>
          </div>
        </div>
        <img
          src={backgroundSrc}
          alt=""
          className="landing-illustration"
          aria-hidden="true"
        />
      </div>
    );
  }
  
  export default Landing ;